//api/action-logs/create
export function logAction() {
    return {
        "success": true,
        "msg": "Action log created successfully",
        "data": {
            "status": "success",
            "_id": "69e840fafe5668006a7b02e1",
            "user": "68c272e642a018006930c297",
            "company": "SparkleTime KeepingDemo",
            "userDisplay": {
                "name": "Demo Users",
                "email": "sparkletimekeepingdemo+01@gmail.com"
            },
            "role": "Store Manager",
            "action": "Created Schedule",
            "category": "Schedule",
            "details": "Successfully created schedule for personnel: Test Account Intern. Date range: Apr 22, 2026 - Apr 22, 2026. Position: test. Time: 11:29 - 17:28. Break: 10 minutes. Total Hours: 5.82",
            "timestamp": "2026-04-22T03:31:06.709Z",
            "createdAt": "2026-04-22T03:31:06.710Z",
            "updatedAt": "2026-04-22T03:31:06.710Z",
            "__v": 0
        }
    }
}